export default "__VITE_ASSET__Bx_04RtD__"